<div class="flex justify-center">
    <div
        class="xs:-mr-[90px] xs:-ml-[35px] xs:w-[calc(100vw-30px)] -mr-[75px] -ml-[24px] block w-[100vw] pt-[56px] transition-all sm:pt-[48px] md:relative md:-mx-[120px] md:w-[768px] md:pt-0 lg:-mx-[80px] xl:-mx-48"
    >
        <ui-m000-c010-image
            class="block h-full"
            [image]="{
                image: car().image.url,
                desktop: { width: 850, height: 433 },
                tablet: { width: 768, height: 433 },
                mobile: { width: 768, height: 433 },
            }"
            [priority]="isFirstView()"
            [alt]="car().image.alt || car().label"
            classList="size-full aspect-[768/433]"
            contain
            highRes
            cover
        />

        @if (car().highlightBadge; as highlightBadge) {
            <ui-m040-c030-badge
                class="disable-on-not-active md:right-unset absolute top-16 block transition-opacity duration-500 md:top-50 md:left-0"
                [ngClass]="lastSlide() ? 'right-0' : 'right-[-64%]'"
                type="accent"
            >
                <div
                    class="font-text flex flex-col items-end py-4 pr-16 text-right text-white md:items-start md:text-left"
                >
                    @if (highlightBadge.value) {
                        @let highlightBadgeUnit = highlightBadge.unit | footnotes;
                        @let highlightBadgeValue = highlightBadge.value | footnotes;
                        @let highlightBadgePrefix = highlightBadge.prefix | footnotes;

                        <span class="text-16">
                            @if (highlightBadge.prefix) {
                                <span [innerHTML]="highlightBadgePrefix()"></span>
                            }
                            <span
                                class="text-20 lg:text-24 mr-4 font-semibold"
                                [innerHTML]="highlightBadgeValue()"
                            ></span>
                            <span class="text-14 contents" [innerHTML]="highlightBadgeUnit()"></span>
                        </span>
                    }
                    @if (highlightBadge.kurztext) {
                        @let highlightBadgeKurztext = highlightBadge.kurztext | footnotes;
                        <span class="text-18 font-medium" [innerHtml]="highlightBadgeKurztext()"></span>
                    }
                </div>
            </ui-m040-c030-badge>
        } @else if (car().badge) {
            <ui-m040-c030-badge
                class="disable-on-not-active xs:left-59 absolute top-16 left-48 block transition-opacity duration-500 md:top-50 md:left-100"
                type="blue"
            >
                {{ car().badge }}
            </ui-m040-c030-badge>
        }
    </div>
</div>
